import { OTPInput, REGEXP_ONLY_DIGITS } from "input-otp";

interface Props {
  value: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  disabled?: boolean;
  error?: string;
}

export default function VerificationCodeInput({
  value,
  onChange,
  onBlur,
  disabled = false,
  error,
}: Props) {
  return (
    <div>
      <label
        htmlFor="signin-verification-code"
        className="block font-SatoshiM text-base leading-6 text-bblue"
      >
        6-digit code
        <sup aria-hidden="true" className="ml-0.5 text-xs text-ERROR">
          *
        </sup>
      </label>

      <OTPInput
        id="signin-verification-code"
        name="code"
        maxLength={6}
        pattern={REGEXP_ONLY_DIGITS}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        required
        autoComplete="one-time-code"
        pasteTransformer={(text) => text.replace(/\D/g, "")}
        aria-invalid={Boolean(error)}
        aria-describedby={error ? "signin-verification-code-error" : undefined}
        containerClassName="mt-5 w-full"
        render={({ slots }) => (
          <div
            aria-hidden="true"
            className="grid w-full grid-cols-6 gap-2 sm:gap-3"
          >
            {slots.map((slot, index) => (
              <div
                key={index}
                className={`relative flex h-16 min-w-0 items-center justify-center rounded-md border bg-LIGHT_BG font-SatoshiM text-2xl text-MAIN_TEXT ${
                  error ? "border-ERROR" : "border-ashShade-3"
                } ${
                  slot.isActive
                    ? "border-bblue ring-2 ring-PRIMARY_ACCENT_ONE"
                    : ""
                }`}
              >
                {slot.char}

                {slot.hasFakeCaret && (
                  <span className="absolute h-6 w-px animate-pulse bg-MAIN_TEXT" />
                )}
              </div>
            ))}
          </div>
        )}
      />

      {error && (
        <p
          id="signin-verification-code-error"
          role="alert"
          className="mt-2 text-sm text-ERROR"
        >
          {error}
        </p>
      )}
    </div>
  );
}
